import * as yup from 'yup'
import {
  INVALID_EMAIL,
  INVALID_PHONE_NUMBER,
  INVALID_MOBILE_NUMBER,
  REQUIRED_FIELD,
  INVALID_FEDERAL_TAX_ID,
  ZIP_CODE_FORMAT_ERROR,
} from 'constants/errors'
import { userPageSchema } from 'components/VendorForm/schema'
import { zipCodeReg } from 'constants/regExp'

export const schemaRepForm = (isEdit: boolean) =>
  yup.object().shape({
    firstName: yup.string().required(REQUIRED_FIELD),
    lastName: yup.string().required(REQUIRED_FIELD),
    nameOnCheck: yup.string(),
    nameOnBankAccount: yup.string(),
    phone: yup
      .string()
      .required(REQUIRED_FIELD)
      .test('isFullPhoneNumber', INVALID_PHONE_NUMBER, (val) => Boolean(val && val.replace(/\s/g, '').indexOf('_') < 0) || !val),
    mobile: yup.string().test('isFullMobileNumber', INVALID_MOBILE_NUMBER, (val) => Boolean(val && val.replace(/\s/g, '').indexOf('_') < 0) || !val),
    email: yup.string().required(REQUIRED_FIELD).email(INVALID_EMAIL),
    fax: yup.string(),
    userPage: userPageSchema(isEdit, 'Representative'),
    businessName: yup.string().required(REQUIRED_FIELD),
    city: yup.string().required(REQUIRED_FIELD),
    street: yup.string().required(REQUIRED_FIELD),
    stateId: yup.number().typeError(REQUIRED_FIELD).required(REQUIRED_FIELD),
    federalTaxId: yup
      .string()
      .test('isFullFederalTaxId', INVALID_FEDERAL_TAX_ID, (val) => Boolean((val && val.replace(/\s/g, '').indexOf('_') < 0) || !val))
      .required(REQUIRED_FIELD),
    zipCode: yup.string().required(REQUIRED_FIELD).matches(zipCodeReg, ZIP_CODE_FORMAT_ERROR),
    availableCompanies: yup
      .array()
      .of(yup.mixed())
      .test('not-null-or-undefined', REQUIRED_FIELD, (val) => Array.isArray(val)),
  })
